import { ColorModeContext, useMode } from "./theme";
import { CssBaseline, ThemeProvider, useMediaQuery } from "@mui/material";
import { Routes, Route } from "react-router-dom";
import {
  Bar,
  Calendar,
  Dashboard,
  Faq,
  Form,
  Geo,
  // Invoices,
  Line,
  Pie,
  Sidebar,
  Signup,
  // Team,
  Topbar,
  Feeds,
  AddFeeds,
  Payments,
  Products,
  ViewProducts,
  LandingPage,
  Orders,
  ViewOrders,
} from "./scenes";
import RequireAuth from "./features/auth/RequireAuth";
import Login from "./features/auth/Login";
import { useSelector } from "react-redux";
import { selectCurrentToken } from "./features/auth/authSlice";
import { MenuOutlined } from "@mui/icons-material";
import { useRef, useState } from "react";
import LandingPages from "./components/LandingPage";
import Cart from "./components/Cart";

function App() {
  const [theme, colorMode] = useMode();
  const token = useSelector(selectCurrentToken);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [showSideView, setShowSideNav] = useState(false);
  const mainDivRef = useRef<null | HTMLDivElement>(null);

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div
          ref={mainDivRef}
          className="w-screen h-screen flex overflow-hidden"
        >
          {isNonMobile && token ? (
            <Sidebar setShowSideNav={setShowSideNav} />
          ) : (
            <>
              {token && (
                <>
                  {showSideView ? (
                    <Sidebar setShowSideNav={setShowSideNav} />
                  ) : (
                    <div
                      className={`
          w-[20px]
          h-[20px]
          absolute
          top-[25px]
          left-0
          z-[1]
          `}
                      onClick={() => setShowSideNav(true)}
                    >
                      <MenuOutlined />
                    </div>
                  )}
                </>
              )}
            </>
          )}
          <main className="content w-[100%] overflow-y-scroll scrollbar">
            {token && (
              <div className="fixed w-[-webkit-fill-available]">
                <Topbar ref={mainDivRef} />
              </div>
            )}
            <Routes>
              {/* PUBLIC ROUTES */}
              <Route index path="/" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/orders" element={<Orders />} />
              <Route
                path="/landingPages/:sponserId/:landingPageId"
                element={<LandingPages />}
              />
              <Route path="/cart" element={<Cart />} />
              <Route path="/signup" element={<Signup />} />
              {/* PROTECTED ROUTES */}
              <Route element={<RequireAuth />}>
                <Route path="/viewOrders" element={<ViewOrders />} />
                <Route path="/viewProducts" element={<ViewProducts />} />
                <Route path="/products" element={<Products />} />
                <Route path="/landingPage" element={<LandingPage />} />
                <Route path="/dashboard" element={<Dashboard />} />
                {/* <Route path="/creators" element={<Team />} /> */}
                {/* <Route path="/contacts" element={<Contacts />} /> */}
                <Route path="/payments" element={<Payments />} />
                {/* <Route path="/invoices" element={<Invoices />} /> */}
                <Route path="/form" element={<Form />} />
                <Route path="/calendar" element={<Calendar />} />
                <Route path="/faq" element={<Faq />} />
                <Route path="/bar" element={<Bar />} />
                <Route path="/pie" element={<Pie />} />
                <Route path="/line" element={<Line />} />
                <Route path="/geography" element={<Geo />} />
                <Route path="/feeds" element={<Feeds />} />
                <Route path="/addFeeds" element={<AddFeeds />} />
              </Route>
            </Routes>
          </main>
        </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;
